import './ThankyouTerminalPage.less';

import * as actions from './redux/actions';

import React, { Component } from 'react';

import { AppData } from '../../services';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import confeti from './../../images/anims/kupos_confetti_alone.json';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';

const operator = JSON.parse(localStorage.getItem('op'));
const themeType = operator && operator.theme_type && operator.theme_type;
export class ThankyouTerminalPage extends Component {
	static propTypes = {
		home: PropTypes.object.isRequired,
		actions: PropTypes.object.isRequired,
	};

	pnr = this.props.location.search.replace('?pnr_number=', '');

	constructor(props) {
		super(props);
		try {
			const { status, pnrNumber } = this.props.match.params;
			this.state = {
				status,
				pnrNumber,
			};
		} catch (e) { }
	}

	handleDownloadTicket = () => {
		const ticketUrl = `${AppData.BASE_URL}airport/${operator.operator_name}/api/booking/${this.pnr}/print-ticket`;
		window.open(ticketUrl, '_blank');
	};

	render() {
		return (
			<div className="home-thankyou-page">
				<style>
					{this.props.home.operator
						? `.tooltip-thank-you-page {
					background-color: ${this.props.home.operator.color_codes.primary_color};
					color: ${this.props.home.operator.color_codes.secondary_color};
				}
				.tooltip-thank-you-page-edge {
					background-color: ${this.props.home.operator.color_codes.primary_color};
				}
				.thank-you-page-button-primary {
					color: ${this.props.home.operator.color_codes.primary_color};
					background-color: ${this.props.home.operator.color_codes.secondary_color};
				}
				.thank-you-page-button-secondary {
					color: white;
					background-color: #ccc !important;
				}
				`
						: ''}
				</style>

				<div className={`${themeType === 11 ? 'thank-you-page-wrapper no-padding' : 'thank-you-page-wrapper'}`}>
					{this.state.status === 'success' ? (
						<div>
							<img
								src={getIcons('success', this.props.home.operator)}
								width={130}
								height={130}
								alt=""
							/>
							<h3 className="text-center bold-text mt-4 mb-4">¡Listo!</h3>
							<p className="text-center" style={{ fontSize: '16px' }}>
								Tu compra fue procesada con éxito. Te enviaremos los detalles de la compra a tu
								correo
							</p>
							<p className="text-center" style={{ fontSize: '16px' }}>
								electrónico. Si no lo consigues, recuerda revisar tu bandeja de correo no deseado o
								spam.
							</p>
							<div className="tooltip-thank-you-page" style={{ fontSize: '15px' }}>
								<div className="tooltip-thank-you-page-edge"></div>
								¡Gracias por comprar con nosotros!
							</div>
							<div className="thank-you-page-btn-container">
								<button
									className="thank-you-page-button thank-you-page-button-primary bold-text"
									onClick={() => this.handleDownloadTicket()}
								>
									DESCARGAR PASAJE
								</button>

								{operator && operator.operator_name === "santarosa" ?
									(<button
										className="thank-you-page-button thank-you-page-button-secondary bold-text"
										onClick={() => this.props.history.push('/')}
									>
										CONTÁCTANOS
									</button>) : (<button
										className="thank-you-page-button thank-you-page-button-secondary bold-text"
										onClick={() => this.props.history.push('/contact')}
									>
										CONTÁCTANOS
									</button>)
								}
							</div>
							{/* <Lottie
                animationData={confeti}
                loop={false}
                style={{
                  position: 'absolute',
                  zIndex: 99,
                  width: '100vw',
                  height: '50vh',
                  top: 212,
                }}
              /> */}
						</div>
					) : (
						<div>
							<img
								src={getIcons('failure', this.props.home.operator)}
								width={130}
								height={130}
								alt=""
							/>
							<h3 className="text-center bold-text mt-4 mb-4">¡Lo sentimos!</h3>
							<p className="text-center mb-4" style={{ fontSize: '15px' }}>
								Algo salió mal y tu pago no pudo ser procesado.
							</p>

							<p className="text-center mb-1" style={{ fontSize: '15px' }}>
								Si estás teniendo problemas para comprar tu pasaje,
							</p>
							<p className="text-center" style={{ fontSize: '15px' }}>
								contáctanos por nuestros canales de atención.
							</p>

							<div className="thank-you-page-btn-container">
								<button
									className="thank-you-page-button thank-you-page-button-primary bold-text"
									onClick={() => this.props.history.push('/contact')}
								>
									CONTÁCTANOS
								</button>
								<button
									className="thank-you-page-button thank-you-page-button-secondary bold-text"
									onClick={() => this.props.history.push('/')}
								>
									IR AL INICIO
								</button>
							</div>
						</div>
					)}
					{/* {this.state.status === 'success' ? (
            <audio
              ref={audio => {
                this.audio = audio;
              }}
              // controls
              autoPlay={true}
              src="https://kupos.s3.amazonaws.com/kupos_success_sound.mpeg"
            />
          ) : null} */}
				</div>
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThankyouTerminalPage);



// WEBPACK FOOTER //
// ./src/features/home/ThankyouTerminalPage.js